'use strict';

module Patersons {

    export class PerformanceReport extends AbstractReport {
        openMarketValue: number;
        netContributionsWithdrawals: number;
        netAssetMovement: number;
        income: number;
        expenses: number;
        managementFees: number;
        closedMarketValue: number;
        irr: number;
        hasData: boolean;
    }


    export class PerformanceReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/performanceReport.component.html';
        controller: any = PerformanceReportController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }

    export class PerformanceReportController extends AbstractReportController {
        report: PerformanceReport;
    }

}

